<template>
  <div class="user-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('user.title') }}</h2>
    </div>

    <CrudTable
      :columns="fields"
      :loader="isLoading"
      :list-url="listUrl"
    >
      <!-- Name Column -->
      <template #cell(full_name)="data">
        <div class="d-flex align-items-center">
          <div class="avatar mr-3">
            {{ getInitials(data.item.full_name) }}
          </div>
          <div>
            <div class="font-weight-bold">{{ data.item.full_name || 'N/A' }}</div>
            <div class="text-muted small">{{ data.item.email || 'N/A' }}</div>
          </div>
        </div>
      </template>

      <template #cell(integration_id)="data">
        <div class="d-flex align-items-center">
          {{ data.item.integration ? data.item.integration.services : 'N/A' }}
        </div>
      </template>
      

    </CrudTable>

    <!-- Delete Confirmation Modal -->
    <!-- <b-modal
      v-model="showDeleteModal"
      :title="$t('user.delete_modal_title')"
      @ok="handleDelete"
      ok-variant="danger"
    >
      {{ $t('user.delete_modal_message') }}
    </b-modal> -->
  </div>
</template>

<script>
import CrudTable from "@/components/CrudTable.vue";

export default {
  name: 'UserList',
  components: {
    CrudTable
  },

  data() {
    return {
      listUrl: '',
      integrationId: null,
      isLoading: false,
      fields: [
        { key: 'object_id', label: this.$t('user.object_id'), sortable: true, sortDirection: 'asc' },
        { key: 'integration_id', label: this.$t('user.integration_service'), sortable: true, sortDirection: 'asc' },
        { key: 'full_name', label: this.$t('user.table_header_user'), sortable: true, sortDirection: 'asc' },
        { key: 'phone', label: this.$t('user.table_header_phone'), sortable: true, sortDirection: 'asc' },
        { key: 'email', label: this.$t('user.email'), sortable: true, sortDirection: 'asc' },
        { key: 'created_at', label: this.$t('user.table_header_created_at'), sortable: true, sortDirection: 'asc' },
      ],
    }
  },
  async created() {
    if(this.$route.params.integration_id) {
        this.integrationId =  this.$route.params.integration_id;
        this.listUrl = `/admin/integration/users/${this.integrationId}`;
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return '';
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase();
    },
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
    }
  }
}
</script>

<style scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>
